import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CardMedia,
  Checkbox,
  Input,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Switch,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import React, { ChangeEvent, useEffect, useState } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import SelectUpload from "../../Modals/select_upload";
import { getFromStorage, STORAGE_KEYS } from "../../helpers";
import { User } from "../../types/User";
import { showError, showToast } from "../../constants/toasts";
import {
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
} from "../../service/auth";
import { Category, VendorStore } from "../../types/General";
import { useFormik } from "formik";
import * as Yup from "yup";
import { VENDOR_PROFILE_STEPS } from "../../utils/enums";
import { UploadMedia, Uploadpdf } from "../../utils/mediaUpload";
import PhoneInput from "react-phone-input-2";
import {
  useLazyGetCategoryQuery,
  useLazyGetSubCategoryQuery,
} from "../../service/main";
import { GridCloseIcon } from "@mui/x-data-grid";
import Loader from "../../constants/Loader";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const bioTemplates = [
  "Handcrafted products made with passion in the UAE",
  "Locally made goods inspired by modern heritage and tradition",
  "Unique curated items from a licensed UAE home business",
  // Admin can add/edit templates here
];

const storeMottoTemplates = [
  "Crafted with Care",
  "Made in the UAE",
  "Celebrate Local Creativity",
  // Admin can add more here
];

const storeStoryTemplates = [
  "Born from a passion for craftsmanship, our store celebrates local artisans and the beauty of handmade traditions...",
  "Inspired by UAE heritage, our brand blends modern aesthetics with timeless cultural values...",
  "Built by creators for creators, our store is a home for unique products made with soul and purpose...",
];
const selectedCategory = "fashion";
const careInstructionTemplates = {
  fashion: [
    "Hand wash with cold water. Do not bleach.",
    "Dry flat in shade. Avoid machine drying.",
  ],
  homeFragrance: [
    "Keep away from direct sunlight. Store in a cool area.",
    "Avoid placing near heat sources. Keep bottle tightly sealed.",
  ],
  accessories: [
    "Avoid contact with water and perfumes.",
    "Store in a dry place. Keep away from sharp objects.",
  ],
};

const pickupInstructionOptions = [
  "Call before arrival",
  "Leave at reception",
  "Ring doorbell",
  "Parking available",
  "Custom instruction",
];

const ALL_PLACES = [
  "Dubai",
  "Abu Dhabi",
  "Sharjah / Ajman",
  "RAK",
  "Fujairah",
  "UAQ",
];

const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box>{children}</Box>}
  </div>
);

const StoreInformation = () => {
  const navigate = useNavigate();
  const userData = getFromStorage(STORAGE_KEYS.userData);

  const isPdf = (file: File) => file.type === "application/pdf";

  const parsedUserData: User | null = userData
    ? (JSON.parse(userData) as User)
    : null;

  const [getProfile] = useLazyGetProfileQuery();
  const [updateProfile] = useUpdateProfileMutation();
  const [getCategory] = useLazyGetCategoryQuery();
  const [getSubCategory] = useLazyGetSubCategoryQuery();
  const [fastDeliveryEnabled, setFastDeliveryEnabled] = useState(false);
  const [valueTabs, setValueTabs] = useState<number>(0);
  const [valueTabs1, setValueTabs1] = useState<number>(0);
  const [selectedTime, setSelectedTime] = useState("15:00");
  const [scope, setScope] = useState<"all" | "specific">("all");
  const [places, setPlaces] = useState<string[]>(ALL_PLACES);

  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const handleNextTab = () => {
    if (valueTabs < 4) {
      setValueTabs((prev) => prev + 1);
    }
  };

  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });
  const [categories, setCategories] = useState<Category[]>([]);
  const [subCategories, setSubCategories] = useState<Category[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState<string[]>(
    []
  );
  const [openCategory, setOpenCategory] = useState(false);
  const [openSubCategory, setOpenSubCategory] = useState(false);
  const [vendorData, setVendorData] = useState<VendorStore | null>(null);
  const [selectedAddress, setSelectedAddress] = useState<string>("");
  const [selectedCommitments, setSelectedCommitments] = useState<string[]>([]);

  const handleItemClick = (
    event: React.MouseEvent,
    value: string,
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    const selectedIndex = selectedItems.indexOf(value);
    let newSelected: string[] = [];

    if (selectedIndex === -1) newSelected = [...selectedItems, value];
    else newSelected = selectedItems.filter((v) => v !== value);

    setSelectedItems(newSelected);
  };

  const handleSelectAll = (
    event: React.MouseEvent,
    allItems: string[],
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    if (selectedItems.length === allItems.length) setSelectedItems([]);
    else setSelectedItems(allItems);
  };

  const [pickupOption, setPickupOption] = useState("");
  const [selectedInstruction, setSelectedInstruction] = useState("");
  const [customInstruction, setCustomInstruction] = useState("");
  // ========================== STATE ==========================
  const [deliverySLA, setDeliverySLA] = useState("1"); // default based on category

  const [selectedMotto, setSelectedMotto] = useState("");
  const [customMotto, setCustomMotto] = useState("");
  const [storeStory, setStoreStory] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [showStoryEditor, setShowStoryEditor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [banner, setBanner] = useState("");

  const [tradeLicense, setTradeLicense] = useState<{
    url: string;
    isPdf: boolean;
  } | null>(null);
  const [moa, setMoa] = useState<{ url: string; isPdf: boolean } | null>(null);

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    formik.setFieldValue("countryCode", country?.dialCode);
  };

  const handleChangeShippingPhone = (phone: any, country: any) => {
    ShippingFormik.setFieldValue(
      "contactPhone",
      phone?.replace(country.dialCode, "")
    );
    ShippingFormik.setFieldValue("contactCountryCode", country?.dialCode);
  };

  const handleChange =
    (label: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        setSelectedCommitments((prev) => [...prev, label]);
      } else {
        setSelectedCommitments((prev) => prev.filter((item) => item !== label));
      }
    };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      if (type === "profile") {
        setImage("");
      } else {
        setBanner("");
      }

      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      if (type === "profile") {
        setImage(imageUrl?.data || "");
      } else {
        setBanner(imageUrl?.data || "");
      }
    }
  };

  const handleUploadDoc = async (
    event: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const file = event.target.files?.[0];

    if (!file) {
      type === "moa" ? setMoa(null) : setTradeLicense(null);
      return;
    }

    const uploaded = await Uploadpdf(file);

    if (uploaded?.data) {
      const fileData = {
        url: uploaded.data,
        isPdf: file.type === "application/pdf",
      };

      if (type === "moa") {
        setMoa(fileData);
      } else {
        setTradeLicense(fileData);
      }
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      shortName: vendorData?.shortName || "",
      storeName: vendorData?.storeName || "",
      email: parsedUserData?.email || "",
      phone: vendorData?.phone || "",
      countryCode: vendorData?.countryCode || "",
      licencse: vendorData?.licenceNumber || "",
      bio: vendorData?.description || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      shortName: Yup.string().required().required("Short Name is required"),
      storeName: Yup.string().required().required("Store Name is required"),
      licencse: Yup.string().required().required("License is required"),
      bio: Yup.string().required().required("Bio is required"),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);

      // if (!image) {
      //   showError("Please upload image");
      //   return;
      // }

      if (!selectedCategories?.length || !selectedSubCategories?.length) {
        return;
      }

      const body = {
        logo: image || "",
        shortName: values.shortName,
        storeName: values.storeName,
        email: values.email,
        countryCode: values.countryCode,
        phone: values.phone,
        licenceNumber: values.licencse,
        storeAddress: selectedAddress,
        category: selectedCategories,
        subCategory: selectedSubCategories,
        description: values.bio,
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          setError(false);
          getProfileAPi();
          showToast(response?.message || "");
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const BankFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      accountName: vendorData?.bankDetails?.accountName || "",
      bankName: vendorData?.bankDetails?.bankName || "",
      iban: vendorData?.bankDetails?.iban || "",
      swift: vendorData?.bankDetails?.swift || "",
      branch: vendorData?.bankDetails?.branch || "",
    },
    validationSchema: Yup.object({
      accountName: Yup.string().required("Holder's name is required"),
      bankName: Yup.string().required("Bank name is required"),
      iban: Yup.string().required("IBAN is required"),
    }),
    onSubmit: async (values: any) => {
      BankFormik.setSubmitting(true);

      const body = {
        bankDetails: {
          accountName: values.accountName || "",
          bankName: values.bankName || "",
          iban: values.iban || "",
          swift: values.swift || "",
          branch: values.branch || "",
          document: "",
        },
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          showToast(response?.message || "");
          getProfileAPi();
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const BrandFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      motto: vendorData?.storeMotto || "",
      story: vendorData?.storeStory || "",
    },
    validationSchema: Yup.object({
      motto: Yup.string().required("Store Motto is required"),
      story: Yup.string().required("Store Story is required"),
    }),
    onSubmit: async (values: any) => {
      BankFormik.setSubmitting(true);

      if (!banner) {
        showError("Please upload a banner image");
        return;
      }

      const body = {
        storeBanner: banner,
        storeMotto: values.motto,
        storeStory: values.story,
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          showToast(response?.message || "");
          getProfileAPi();
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const StorePolicyFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      storeCareInfo: vendorData?.storeCareInfo || "",
    },
    validationSchema: Yup.object({
      storeCareInfo: Yup.string().required("Care info is required"),
    }),
    onSubmit: async (values: any) => {
      BankFormik.setSubmitting(true);

      if (!selectedCommitments.length) {
        showError("Please select at least one commitment");
        return;
      }

      const body = {
        storeCareInfo: values.storeCareInfo,
        customerTrustInfo: selectedCommitments,
        step: VENDOR_PROFILE_STEPS.POLICIES,
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          showToast(response?.message || "");
          getProfileAPi();
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const SocialFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      facebook: vendorData?.socialLinks?.facebook || "",
      instagram: vendorData?.socialLinks?.instagram || "",
      twitter: vendorData?.socialLinks?.twitter || "",
      tiktok: vendorData?.socialLinks?.tiktok || "",
    },
    onSubmit: async (values: any) => {
      BankFormik.setSubmitting(true);

      const body = {
        socialLinks: {
          facebook: SocialFormik.values.facebook || "",
          instagram: SocialFormik.values.instagram || "",
          twitter: SocialFormik.values.twitter || "",
          tiktok: SocialFormik.values.tiktok || "",
        },
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          showToast(response?.message || "");
          getProfileAPi();
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const ShippingFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      shippingAddress: vendorData?.shippingAddress?.detail || "",
      contactPhone: vendorData?.shippingContact?.phone || "",
      contactCountryCode: vendorData?.shippingContact?.countryCode || "",
      allowNonReturnableProducts:
        vendorData?.allowNonReturnableProducts || false,
      pickupInstructions: vendorData?.pickupInstructions || "",
    },
    validationSchema: Yup.object({
      shippingAddress: Yup.string().required("Shipping Address is required"),
    }),
    onSubmit: async (values: any) => {
      BankFormik.setSubmitting(true);

      const body = {
        shippingAddress: {
          detail: values.shippingAddress,
        },
        shippingContact: {
          name: parsedUserData?.name || "",
          phone: values.contactPhone || "",
          countryCode: values.contactCountryCode || "+971",
        },
        pickupInstructions: values.pickupInstructions,
        allowNonReturnableProducts: values.allowNonReturnableProducts,
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          showToast(response?.message || "");
          getProfileAPi();
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const handleUpdateDoc = async () => {
    setLoading(true);
    try {
      const response = await updateProfile({
        tradeLicense: tradeLicense?.url,
        moa: moa?.url,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        showToast(response?.message || "");
        getProfileAPi();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const convertToUTC = (time: string) => {
    const [hours, minutes] = time.split(":").map(Number);

    const date = new Date();
    date.setHours(hours, minutes, 0, 0);

    return date.toISOString(); // UTC
  };

  const handleScopeChange = (e: any) => {
    const value = e.target.value;
    setScope(value);

    if (value === "all") {
      setPlaces(ALL_PLACES); // select all
    } else {
      setPlaces([]); // reset for manual selection
    }
  };

  const handlePlaceToggle = (place: string) => {
    setPlaces((prev) =>
      prev.includes(place) ? prev.filter((p) => p !== place) : [...prev, place]
    );
  };

  const DeliveryFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      returnAddress: vendorData?.returnAddress?.detail || "",
      sameAsPickup: false,
      returnPolicyType: vendorData?.returnWithIn || "Standard Return – 7 days",
      returnPolicyValue: vendorData?.returnWithIn || "Standard Return – 7 days",
      isSameDayDelivery: vendorData?.isSameDayDelivery || false,
    },
    validationSchema: Yup.object({
      returnAddress: Yup.string().required("Return address is required"),
      returnPolicyValue: Yup.string().required(
        "Return policy value is required"
      ),
    }),
    onSubmit: async (values: any) => {
      BankFormik.setSubmitting(true);

      if (!deliverySLA) {
        showError("Delivery SLA is required");
        return;
      }

      if (fastDeliveryEnabled && !selectedTime) {
        return;
      }

      if (fastDeliveryEnabled && !places?.length) {
        showError("Please select Region Availability");
        return;
      }

      const body = {
        deliverySLA: Number(deliverySLA),
        enableFastDelivery: fastDeliveryEnabled,
        ...(fastDeliveryEnabled
          ? { isSameDayDelivery: values.isSameDayDelivery }
          : {}),
        ...(fastDeliveryEnabled
          ? { cutOffTime: convertToUTC(selectedTime) }
          : {}),
        ...(fastDeliveryEnabled ? { regionsAvailable: places } : {}),
        returnWithIn: values.returnPolicyValue,
        returnAddress: {
          detail: values.returnAddress,
        },
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          showToast(response?.message || "");
          getProfileAPi();
          setError(false);
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const mapDoc = (url: string | null) => {
    if (!url) return null;

    return {
      url,
      isPdf: url.toLowerCase().endsWith(".pdf"),
    };
  };

  const getProfileAPi = async () => {
    const categoryIds: string[] = [];
    const subCategoryIds: string[] = [];

    setLoading(true);
    try {
      const response = await getProfile({
        id: parsedUserData?.id,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setVendorData(response?.data || null);
        setImage(response?.data?.logo || "");
        setSelectedAddress(response?.data?.storeAddress || "");

        setBanner(response?.data?.storeBanner);
        setSelectedCommitments(response?.data?.customerTrustInfo || []);
        setSelectedInstruction(response?.data?.pickupInstructions || "");
        setDeliverySLA(response?.data?.deliverySLA || "1");
        setFastDeliveryEnabled(response?.data?.enableFastDelivery || false);

        setMoa(mapDoc(response?.data?.moa));
        setTradeLicense(mapDoc(response?.data?.tradeLicense));

        response?.data?.categories?.forEach((item: any) => {
          if (item?.parentId === null) {
            categoryIds?.push(item?.id);
          } else {
            subCategoryIds?.push(item?.id);
          }
        });

        setSelectedCategories(categoryIds);
        setSelectedSubCategories(subCategoryIds);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCategoryApi = async () => {
    setLoading(true);
    try {
      const response = await getCategory({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCategories(response?.data?.data || []);
      } else {
        setCategories([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getSubCategoryApi = async () => {
    setLoading(true);
    try {
      const parentIds = selectedCategories?.map((item) => item).join(",");

      const response = await getSubCategory({
        parentId: parentIds,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setSubCategories(response?.data?.data || []);
      } else {
        setSubCategories([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getProfileAPi();
    getCategoryApi();
  }, []);

  useEffect(() => {
    if (selectedCategories?.length) {
      getSubCategoryApi();
    }
  }, [selectedCategories]);

  return (
    <>
      <Loader isLoad={loading} />

      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Manage Store Information</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            Manage Store Profile
          </p>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/store-management/add")}
          >
            Add Store
          </Button>
        </div>
      </div>

      <div className="cards view_page profile_page_tab">
        <div className="table_header ">
          <div className="left_s">
            <h2></h2>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary">
              <EditIcon /> Edit Information
            </Button>
          </div>
        </div>
        <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
          <Tabs
            value={valueTabs1}
            onChange={handleChangeTabs1}
            aria-label="view product tabs"
            className="custom_tabs_links tabs_img1"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Store Information" {...a11yProps(0)} />
            <Tab label="Legal & Documents" {...a11yProps(1)} />
            <Tab label="Subscription Plan" {...a11yProps(2)} />
            <Tab
              label="Financial Setup"
              icon={<InfoIcon />}
              {...a11yProps(3)}
            />
            <Tab label="Store Branding" {...a11yProps(4)} />
            <Tab label="Store Policies" {...a11yProps(5)} />
            <Tab label="Shipping & Logistics" {...a11yProps(6)} />
            <Tab label="Delivery & Return Settings" {...a11yProps(7)} />
            <Tab label="Social Media Links" {...a11yProps(8)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs1} index={0}>
          <form className="form" onSubmit={formik.handleSubmit}>
            {/* IMAGE UPLOAD */}
            <div className="gap_p">
              <div className="control_group w_100">
                <label htmlFor="icon-button-file">Upload Logo</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(e: any) => {
                        handleProfileUpload(e, "profile");
                        e.target.value = null;
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* OWNER NAME */}
              <div className="control_group w_33">
                <label htmlFor="ownerName">Short Name </label>
                <TextField
                  id="shortName"
                  name="shortName"
                  placeholder="Enter Short Name"
                  className="text_field"
                  fullWidth
                  value={formik.values.shortName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.shortName &&
                    typeof formik.errors.shortName === "string"
                      ? formik.errors.shortName
                      : ""
                  }
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="ownerName">Store Name</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Store Name"
                  className="text_field"
                  fullWidth
                  value={formik.values.storeName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.storeName &&
                    typeof formik.errors.storeName === "string"
                      ? formik.errors.storeName
                      : ""
                  }
                />
              </div>

              {/* PHONE NUMBER */}

              {/* EMAIL */}
              <div className="control_group w_33">
                <label htmlFor="email">Contact Email </label>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  className="text_field"
                  placeholder="Enter Email Address"
                  disabled
                  fullWidth
                  value={formik.values.email}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.email &&
                    typeof formik.errors.email === "string"
                      ? formik.errors.email
                      : ""
                  }
                />
              </div>

              <div className="control_group w_33">
                <label>Phone Number*</label>
                <PhoneInput
                  enableSearch
                  value={formik.values.countryCode + formik.values.phone}
                  country={"uae"}
                  disabled
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%" }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                />
                <p className="err_msg">
                  {error && !formik.values.phone?.length
                    ? "Phone number is required"
                    : ""}
                </p>
              </div>

              <div className="control_group w_33">
                <label htmlFor="phone">License Number</label>
                <TextField
                  id="licencse"
                  name="licencse"
                  placeholder="Enter License number"
                  fullWidth
                  value={formik.values.licencse}
                  className="text_field"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.licencse &&
                    typeof formik.errors.licencse === "string"
                      ? formik.errors.licencse
                      : ""
                  }
                />
              </div>
              {/* <div className="control_group w_33">
                <label htmlFor="storeName">Country</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Country"
                  fullWidth
                />
              </div> */}
              <div className="control_group w_33">
                <label htmlFor="storeName">Store Address (Emirate)</label>
                <Select
                  displayEmpty
                  fullWidth
                  value={selectedAddress}
                  onChange={(e) => setSelectedAddress(e.target.value)}
                >
                  <MenuItem disabled value="">
                    Select Address
                  </MenuItem>
                  <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="Dubai">Dubai</MenuItem>
                  <MenuItem value="Sharjah">Sharjah</MenuItem>
                  <MenuItem value="Ajman">Ajman</MenuItem>
                  <MenuItem value="Umm al-Quwain">Umm al-Quwain</MenuItem>
                  <MenuItem value="Ras al-Khaimah">Ras al-Khaimah</MenuItem>
                  <MenuItem value="Fujairah">Fujairah</MenuItem>
                </Select>
                {error && !selectedAddress ? (
                  <h6 className="err_msg">Address is required</h6>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="control_group w_33">
                <label htmlFor="storeName">Address</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Address"
                  fullWidth
                />
              </div> */}

              <div className="control_group w_33">
                <label htmlFor="category">
                  Category{" "}
                  <Tooltip
                    title="To change the category you need to send a request to admin"
                    enterTouchDelay={0}
                    leaveTouchDelay={1000}
                  >
                    <span className="info_icon">
                      <InfoOutlinedIcon fontSize="small" />
                    </span>
                  </Tooltip>
                </label>

                <Select
                  multiple
                  displayEmpty
                  open={openCategory}
                  onOpen={() => setOpenCategory(true)}
                  onClose={() => setOpenCategory(false)}
                  value={selectedCategories}
                  renderValue={(selected) => {
                    if ((selected as string[]).length === 0) {
                      return (
                        <span style={{ color: "#999" }}>Select Category</span>
                      );
                    }
                    return (selected as string[])
                      .map(
                        (id) => categories.find((cat) => cat.id === id)?.name
                      )
                      .filter(Boolean)
                      .join(", ");
                  }}
                  fullWidth
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 300 } },
                  }}
                >
                  {/* Select All / Clear All */}
                  <MenuItem
                    value="all"
                    onClick={(e) =>
                      handleSelectAll(
                        e,
                        categories?.map((cat) => cat?.id),
                        selectedCategories,
                        setSelectedCategories
                      )
                    }
                  >
                    <Checkbox
                      checked={
                        categories.length > 0 &&
                        selectedCategories.length === categories.length
                      }
                      indeterminate={
                        selectedCategories.length > 0 &&
                        selectedCategories.length < categories.length
                      }
                    />
                    <ListItemText
                      primary={
                        selectedCategories.length === categories.length
                          ? "Clear All"
                          : "Select All"
                      }
                    />
                  </MenuItem>

                  {categories?.map((cat) => (
                    <MenuItem
                      key={cat?.id}
                      value={cat?.id}
                      onClick={(e) =>
                        handleItemClick(
                          e,
                          cat?.id,
                          selectedCategories,
                          setSelectedCategories
                        )
                      }
                    >
                      <Checkbox
                        checked={selectedCategories.includes(cat?.id)}
                      />
                      <ListItemText primary={cat?.name} />
                    </MenuItem>
                  ))}
                </Select>
                {error && !selectedCategories?.length ? (
                  <h6 className="err_msg">Category is required</h6>
                ) : (
                  ""
                )}
              </div>

              {/* ---------- SUB-CATEGORY SELECT ---------- */}
              <div className="control_group w_33">
                <label htmlFor="subCategory">
                  Sub-Category{" "}
                  <Tooltip
                    title="Once submitted, your request will be reviewed by the admin team to ensure alignment with your registered trade license."
                    enterTouchDelay={0}
                    leaveTouchDelay={1000}
                  >
                    <span className="info_icon">
                      <InfoOutlinedIcon fontSize="small" />
                    </span>
                  </Tooltip>
                </label>

                <Select
                  multiple
                  displayEmpty
                  open={openSubCategory}
                  disabled={!selectedCategories?.length}
                  onOpen={() => setOpenSubCategory(true)}
                  onClose={() => setOpenSubCategory(false)}
                  value={selectedSubCategories}
                  renderValue={(selected) => {
                    if ((selected as string[]).length === 0) {
                      return (
                        <span style={{ color: "#999" }}>
                          Select Sub-Category
                        </span>
                      );
                    }
                    return (selected as string[])
                      .map(
                        (id) =>
                          subCategories?.find((cat) => cat.id === id)?.name
                      )
                      .filter(Boolean)
                      .join(", ");
                  }}
                  fullWidth
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 300 } },
                  }}
                >
                  {/* Select All / Clear All */}
                  <MenuItem
                    value="all"
                    onClick={(e) =>
                      handleSelectAll(
                        e,
                        subCategories?.map((cat) => cat?.id),
                        selectedSubCategories,
                        setSelectedSubCategories
                      )
                    }
                  >
                    <Checkbox
                      checked={
                        subCategories.length > 0 &&
                        selectedSubCategories.length === subCategories.length
                      }
                      indeterminate={
                        selectedSubCategories.length > 0 &&
                        selectedSubCategories.length < subCategories.length
                      }
                    />
                    <ListItemText
                      primary={
                        selectedSubCategories.length === subCategories.length
                          ? "Clear All"
                          : "Select All"
                      }
                    />
                  </MenuItem>

                  {subCategories?.map((sub) => (
                    <MenuItem
                      key={sub?.name}
                      value={sub?.id}
                      onClick={(e) =>
                        handleItemClick(
                          e,
                          sub?.id,
                          selectedSubCategories,
                          setSelectedSubCategories
                        )
                      }
                    >
                      <Checkbox
                        checked={selectedSubCategories.includes(sub?.id)}
                      />
                      <ListItemText primary={sub?.name} />
                    </MenuItem>
                  ))}
                </Select>
                {error && !selectedSubCategories?.length ? (
                  <h6 className="err_msg">Sub-Category is required</h6>
                ) : (
                  ""
                )}
              </div>

              <div className="control_group w_100 ai_rec_btn">
                <label htmlFor="phoneNumber">
                  Store Bio
                  <p style={{ margin: "0" }}>(250 characters maximum)</p>
                </label>
                <TextField
                  id="bio"
                  name="bio"
                  className="text_field"
                  placeholder="Enter Store Bio"
                  type="tel"
                  multiline
                  fullWidth
                  value={formik.values.bio}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.bio && typeof formik.errors.bio === "string"
                      ? formik.errors.bio
                      : ""
                  }
                />
                <Select fullWidth value={"default"} className="select_abs">
                  <MenuItem disabled value="default">
                    Select Template
                  </MenuItem>
                  {bioTemplates.map((template, index) => (
                    <MenuItem value="All">{template}</MenuItem>
                  ))}
                </Select>
                <Button className="btn btn_primary sm">
                  {" "}
                  <img src="/static/images/ai_icon.svg" alt="" />
                  Enhance with AI{" "}
                </Button>
              </div>

              <div className="form_btn">
                {/* <Button className="btn btn_primary" variant="contained" onClick={() => setOpenModal(true)}>
                  Edit
                </Button> */}
                <Button
                  className="btn btn_primary"
                  type="submit"
                  variant="contained"
                  onClick={() => setError(true)}
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={1}>
          <form className="form wrap_viewDemo_steps ">
            <div className="gap_p">
              <div className="title_inner">
                <h3>Trade License Information</h3>
              </div>
              <div className="control_group w_50">
                <label htmlFor="icon-button-file">Trade License Document</label>
                {tradeLicense ? (
                  <div>
                    <div style={{ position: "relative" }}>
                      <figure>
                        {tradeLicense?.isPdf ? (
                          <div className="pdf_preview">
                            <img
                              style={{ width: "50px", height: "50px" }}
                              src="/static/images/pdf.png"
                              alt="pdf"
                            />
                            <p>PDF Document</p>
                          </div>
                        ) : (
                          <CardMedia
                            component="img"
                            image={tradeLicense?.url}
                            alt="doc"
                            style={{
                              height: "140px",
                              borderRadius: "12px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </figure>
                      <GridCloseIcon
                        style={{
                          color: "white",
                          position: "absolute",
                          right: 5,
                          top: 5,
                          backgroundColor: "red",
                          borderRadius: "50%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setTradeLicense(null);
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="upload_box">
                    <label className="upload_action">
                      <input
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={(e: any) => {
                          handleUploadDoc(e, "trade_license");
                          e.target.value = null;
                        }}
                      />
                      <p>
                        <img src="/static/images/upload_icon.svg" alt="icon" />
                        <strong>Click to upload or drag and drop</strong>
                      </p>
                    </label>
                  </div>
                )}
              </div>
              <div className="control_group w_50">
                <label htmlFor="icon-button-file">
                  Memorandum of Association (MOA)(Optional){" "}
                </label>
                {moa ? (
                  <div>
                    <div style={{ position: "relative" }}>
                      <figure>
                        {moa?.isPdf ? (
                          <div className="pdf_preview">
                            <img
                              style={{ width: "50px", height: "50px" }}
                              src="/static/images/pdf.png"
                              alt="pdf"
                            />
                            <p>PDF Document</p>
                          </div>
                        ) : (
                          <CardMedia
                            component="img"
                            image={moa?.url}
                            alt="doc"
                            style={{
                              height: "140px",
                              borderRadius: "12px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </figure>
                      <GridCloseIcon
                        style={{
                          color: "white",
                          position: "absolute",
                          right: 5,
                          top: 5,
                          backgroundColor: "red",
                          borderRadius: "50%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setMoa(null);
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="upload_box">
                    <label className="upload_action">
                      <input
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={(e: any) => {
                          handleUploadDoc(e, "moa");
                          e.target.value = null;
                        }}
                      />
                      <p>
                        <img src="/static/images/upload_icon.svg" alt="icon" />
                        <strong>Click to upload or drag and drop</strong>
                      </p>
                    </label>
                  </div>
                )}
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained">
                  Verify With AI
                </Button>
                <Button
                  className="btn btn_primary"
                  variant="contained"
                  onClick={handleUpdateDoc}
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={2}>
          <div className="pricing-wrapper">
            <div className="ai_recommendation">
              <figure>
                <img src="/static/images/ai_icon.svg" alt="icon" />
              </figure>

              <h3>AI Recommendation</h3>
              <p>Pro subscription will be best as per your store.</p>
            </div>
            <div className="pricing-container">
              {/* Free Plan */}
              <div className="pricing-card special">
                <div className="icon">🎁</div>
                <h3>Free</h3>
                <h2>
                  AED 0 <span>forever</span>
                </h2>
                <ul>
                  <li>Up to 10 products</li>
                  <li>Basic analytics</li>
                  <li>Email support</li>
                  <li>Payout Speed 48h</li>
                  <li>Standard processing</li>
                </ul>
              </div>

              {/* Grow Plan */}

              {/* Pro Plan */}
              <div className="pricing-card">
                <div className="icon">💼</div>
                <p className="suggested">
                  <img src="/static/images/ai_icon.svg" alt="" />
                  AI Recommended
                </p>
                <h3>Pro</h3>
                <h2>
                  AED 249 <span>per month</span>
                </h2>
                <ul>
                  <li>Unlimited products</li>
                  <li>Full AI suite</li>
                  <li>Premium analytics</li>
                  <li>Dedicated account manager</li>
                  <li>Advanced marketing automation</li>
                  <li>Payout Speed 5d</li>
                  <li>Early access to features</li>
                </ul>
              </div>

              {/* Youth Plan */}
              <div className="pricing-card ">
                <div className="icon">🎁</div>
                <h3>Youth Innovators</h3>
                <h2>
                  Free <span>for under 18</span>
                </h2>
                <ul>
                  <li>All Pro features</li>
                  <li>Mentorship program</li>
                  <li>Educational resources</li>
                  <li>Payout Speed 10d</li>
                  <li>Special recognition badge</li>
                </ul>
              </div>

              {/* Pro Plan */}
              <div className="pricing-card">
                <div className="icon">💼</div>
                <h3>Pro</h3>
                <h2>
                  AED 249 <span>per month</span>
                </h2>
                <ul>
                  <li>Unlimited products</li>
                  <li>Full AI suite</li>
                  <li>Premium analytics</li>
                  <li>Dedicated account manager</li>
                  <li>Advanced marketing automation</li>
                  <li>Payout Speed 5d</li>
                  <li>Early access to features</li>
                </ul>
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Save</Button>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={3}>
          <form className="form" onSubmit={BankFormik.handleSubmit}>
            <div className="gap_p">
              {/* Account Holder Name */}
              <div className="control_group w_50">
                <label htmlFor="accountHolder">Account Holder’s Name</label>
                <TextField
                  id="accountName"
                  name="accountName"
                  placeholder="Enter Account Holder’s Name"
                  fullWidth
                  className="text_field"
                  value={BankFormik.values.accountName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      BankFormik.handleChange(val);
                    }
                  }}
                  onBlur={BankFormik.handleBlur}
                  helperText={
                    BankFormik.touched.accountName &&
                    typeof BankFormik.errors.accountName === "string"
                      ? BankFormik.errors.accountName
                      : ""
                  }
                />
              </div>

              {/* Bank */}
              <div className="control_group w_50">
                <label htmlFor="bankName">Bank Name</label>
                <TextField
                  id="bankName"
                  name="bankName"
                  placeholder="Enter Account Holder’s Name"
                  fullWidth
                  className="text_field"
                  value={BankFormik.values.bankName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      BankFormik.handleChange(val);
                    }
                  }}
                  onBlur={BankFormik.handleBlur}
                  helperText={
                    BankFormik.touched.bankName &&
                    typeof BankFormik.errors.bankName === "string"
                      ? BankFormik.errors.bankName
                      : ""
                  }
                />
              </div>

              {/* IBAN */}
              <div className="control_group w_50">
                <label htmlFor="iban">IBAN Number</label>
                <TextField
                  id="iban"
                  name="iban"
                  placeholder="Enter Number"
                  fullWidth
                  className="text_field"
                  value={BankFormik.values.iban}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      BankFormik.handleChange(val);
                    }
                  }}
                  onBlur={BankFormik.handleBlur}
                  helperText={
                    BankFormik.touched.iban &&
                    typeof BankFormik.errors.iban === "string"
                      ? BankFormik.errors.iban
                      : ""
                  }
                />
              </div>

              {/* --- ADVANCED OPTIONS ACCORDION --- */}
              <div className="control_group w_100 accordions_drop">
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <strong>Advanced Options</strong>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div
                      className="gap_p"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {/* Swift / BIC Code */}
                      <div className="control_group w_50">
                        <label htmlFor="swiftCode">
                          Swift/BIC Code (Optional)
                        </label>
                        <TextField
                          id="swift"
                          name="swift"
                          placeholder="Enter Code"
                          fullWidth
                          className="text_field"
                          value={BankFormik.values.swift}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              BankFormik.handleChange(val);
                            }
                          }}
                          onBlur={BankFormik.handleBlur}
                          helperText={
                            BankFormik.touched.swift &&
                            typeof BankFormik.errors.swift === "string"
                              ? BankFormik.errors.swift
                              : ""
                          }
                        />
                      </div>

                      {/* Bank Branch */}
                      <div className="control_group w_50">
                        <label htmlFor="bankBranch">
                          Bank Branch (Optional)
                        </label>
                        <TextField
                          id="branch"
                          name="branch"
                          placeholder="Enter Branch Name"
                          fullWidth
                          className="text_field"
                          value={BankFormik.values.branch}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              BankFormik.handleChange(val);
                            }
                          }}
                          onBlur={BankFormik.handleBlur}
                          helperText={
                            BankFormik.touched.branch &&
                            typeof BankFormik.errors.branch === "string"
                              ? BankFormik.errors.branch
                              : ""
                          }
                        />
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="form_btn">
                <Button
                  className="btn btn_primary"
                  type="submit"
                  variant="contained"
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={4}>
          <form className="form" onSubmit={BrandFormik.handleSubmit}>
            <div className="gap_p">
              {/* ------------------- STORE BANNER ------------------- */}
              <div className="control_group wrap_viewDemo_steps">
                <label>Store Banner</label>
                {banner ? (
                  <div>
                    <div style={{ position: "relative" }}>
                      <figure>
                        <CardMedia
                          style={{
                            height: "150px",
                            borderRadius: "12px",
                            objectFit: "cover",
                          }}
                          component="img"
                          image={banner}
                          alt="photo"
                        />
                      </figure>
                      <GridCloseIcon
                        style={{
                          color: "white",
                          position: "absolute",
                          right: 5,
                          top: 5,
                          backgroundColor: "red",
                          borderRadius: "50%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setBanner("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="upload_box">
                    <label
                      className="upload_action"
                      // onClick={() => setOpenModal(true)}
                    >
                      <p>
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            handleProfileUpload(e, "banner");
                            e.target.value = null;
                          }}
                        />
                        <img src="/static/images/upload_icon.svg" alt="icon" />
                        <strong>Upload Store Banner</strong>
                      </p>
                    </label>
                  </div>
                )}
              </div>

              {/* =================== STORE MOTTO =================== */}
              <div className="control_group ai_rec_btn1">
                <label>Store Motto</label>

                {/* Templates */}

                <Select fullWidth value={"default"} className="select_abs">
                  <MenuItem disabled value="default">
                    Select Motto
                  </MenuItem>
                  {storeMottoTemplates.map((motto, index) => (
                    <MenuItem value="All"> {motto}</MenuItem>
                  ))}
                </Select>

                {/* Custom Input (editable after selecting template OR clicking AI) */}
                <TextField
                  fullWidth
                  placeholder="Enter custom motto"
                  id="motto"
                  name="motto"
                  className="text_field"
                  value={BrandFormik.values.motto}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      BrandFormik.handleChange(val);
                    }
                  }}
                  onBlur={BrandFormik.handleBlur}
                  helperText={
                    BrandFormik.touched.motto &&
                    typeof BrandFormik.errors.motto === "string"
                      ? BrandFormik.errors.motto
                      : ""
                  }
                />

                {/* AI Button */}
                <Button
                  className="btn btn_primary sm"
                  sx={{ mt: 2 }}
                  onClick={() => {
                    // Example AI logic
                    const aiGenerated =
                      "A modern celebration of UAE creativity.";
                    setSelectedMotto(aiGenerated);
                    setCustomMotto("");
                  }}
                >
                  <img
                    style={{ filter: "brightness(0) invert(1)" }}
                    src="/static/images/ai_icon.svg"
                    alt=""
                  />
                  Generate with AI
                </Button>
              </div>

              {/* =================== STORE STORY =================== */}
              <div className="control_group ai_rec_btn">
                <label>Store Story / About Your Brand</label>

                <Select fullWidth value={"default"} className="select_abs">
                  <MenuItem disabled value="default">
                    Select Template
                  </MenuItem>
                  {storeStoryTemplates.map((template, index) => (
                    <MenuItem value="All">{template}</MenuItem>
                  ))}
                </Select>
                <TextField
                  className="mt_20"
                  placeholder="Short Story"
                  hiddenLabel
                  fullWidth
                  multiline
                  id="story"
                  name="story"
                  value={BrandFormik.values.story}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      BrandFormik.handleChange(val);
                    }
                  }}
                  onBlur={BrandFormik.handleBlur}
                  helperText={
                    BrandFormik.touched.story &&
                    typeof BrandFormik.errors.story === "string"
                      ? BrandFormik.errors.story
                      : ""
                  }
                />

                {/* AI Button */}
                <Button
                  className="btn btn_primary sm"
                  onClick={() => {
                    const aiStory =
                      "Our journey began with a mission to empower local creators in the UAE. Every product in our store reflects passion, craftsmanship, and cultural pride...";
                    setStoreStory(aiStory);
                    setShowStoryEditor(true);
                  }}
                >
                  <img
                    style={{ filter: "brightness(0) invert(1)" }}
                    src="/static/images/ai_icon.svg"
                    alt=""
                  />
                  Enhance with AI
                </Button>

                {/* Editable Text Field AFTER template/AI */}
                {showStoryEditor && (
                  <TextField
                    multiline
                    fullWidth
                    minRows={5}
                    placeholder="Write your store story…"
                    value={storeStory}
                    onChange={(e) => setStoreStory(e.target.value)}
                    sx={{ mt: 2 }}
                  />
                )}
              </div>
              <div className="form_btn">
                <Button
                  className="btn btn_primary"
                  variant="contained"
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={5}>
          <form className="form" onSubmit={StorePolicyFormik.handleSubmit}>
            <div className="gap_p return_policy">
              {/* ------------------ C. STORE CARE INSTRUCTIONS ------------------ */}
              <div className="control_group w_100 ai_rec_btn">
                <label htmlFor="careInstructions">
                  Store Care Instructions (Optional)
                  <img src="/static/images/ai_icon.svg" alt="icon" />
                </label>

                <Select fullWidth value={"default"} className="select_abs">
                  <MenuItem disabled value="default">
                    Select Template
                  </MenuItem>
                  {careInstructionTemplates[selectedCategory]?.map(
                    (template, index) => (
                      <MenuItem value="All"> {template}</MenuItem>
                    )
                  )}
                </Select>

                <TextField
                  id="storeCareInfo"
                  name="storeCareInfo"
                  placeholder="Enter"
                  fullWidth
                  multiline
                  className="text_field"
                  value={StorePolicyFormik.values.storeCareInfo}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      StorePolicyFormik.handleChange(val);
                    }
                  }}
                  onBlur={StorePolicyFormik.handleBlur}
                  helperText={
                    StorePolicyFormik.touched.storeCareInfo &&
                    typeof StorePolicyFormik.errors.storeCareInfo === "string"
                      ? StorePolicyFormik.errors.storeCareInfo
                      : ""
                  }
                />

                {/* Optional AI Button */}
                <Button className="btn btn_primary sm" type="button">
                  <img src="/static/images/ai_icon.svg" alt="" />
                  Enhance with AI
                </Button>
              </div>

              {/* ------------------ D. CUSTOMER TRUST COMMITMENT ------------------ */}
              <div className="control_group w_100">
                <label>Customer Trust Commitment</label>
              </div>
              <div className="control_group">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCommitments.includes(
                        "Authenticity Guaranteed"
                      )}
                      onChange={handleChange("Authenticity Guaranteed")}
                    />
                  }
                  label="Authenticity Guaranteed"
                />
              </div>

              <div className="control_group">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCommitments.includes("Secure Payments")}
                      onChange={handleChange("Secure Payments")}
                    />
                  }
                  label="Secure Payments"
                />
              </div>

              <div className="control_group">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCommitments.includes(
                        "Transparent Returns"
                      )}
                      onChange={handleChange("Transparent Returns")}
                    />
                  }
                  label="Transparent Returns"
                />
              </div>

              <div className="control_group">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCommitments.includes("Privacy Policy")}
                      onChange={handleChange("Privacy Policy")}
                    />
                  }
                  label="Privacy Policy"
                />
              </div>

              <div className="form_btn">
                <Button
                  className="btn btn_primary"
                  variant="contained"
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={6}>
          <form className="form" onSubmit={ShippingFormik.handleSubmit}>
            {/* Shipping Method Selection */}
            <Box
              sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2, mb: 3 }}
            >
              <div className="form">
                <div className="gap_p">
                  <div className="title_inner">
                    <h3>Integrated Shipping</h3>
                  </div>

                  {/* ---------------- PRIMARY PICKUP ADDRESS ---------------- */}
                  <div className="control_group w_100">
                    <label>Primary Pickup Address</label>

                    <div className="pickup_address_options">
                      {/* Option 1 */}
                      <FormControlLabel
                        control={
                          <Radio
                            checked={pickupOption === "license"}
                            onChange={() => setPickupOption("license")}
                          />
                        }
                        label="Use License Address (auto-fill)"
                      />

                      {/* Option 2 */}
                      <FormControlLabel
                        control={
                          <Radio
                            checked={pickupOption === "personal"}
                            onChange={() => setPickupOption("personal")}
                          />
                        }
                        label="Use Personal Address (from profile)"
                      />

                      {/* Option 3 */}
                      <FormControlLabel
                        control={
                          <Radio
                            checked={pickupOption === "new"}
                            onChange={() => setPickupOption("new")}
                          />
                        }
                        label="Enter New Address (Google Maps autocomplete)"
                      />
                    </div>

                    {/* If NEW ADDRESS → Show Maps Field */}
                    <TextField
                      id="shippingAddress"
                      name="shippingAddress"
                      placeholder="Address"
                      className="text_field"
                      fullWidth
                      value={ShippingFormik.values.shippingAddress}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          ShippingFormik.handleChange(val);
                        }
                      }}
                      onBlur={ShippingFormik.handleBlur}
                      helperText={
                        ShippingFormik.touched.shippingAddress &&
                        typeof ShippingFormik.errors.shippingAddress ===
                          "string"
                          ? ShippingFormik.errors.shippingAddress
                          : ""
                      }
                    />
                  </div>

                  {/* ---------------- CONTACT PHONE NUMBER ---------------- */}
                  <div className="control_group w_50">
                    <label>Contact Phone Number</label>
                    <PhoneInput
                      enableSearch
                      value={
                        ShippingFormik.values.contactCountryCode +
                        ShippingFormik.values.contactPhone
                      }
                      country={"uae"}
                      inputClass="phoneInput"
                      onChange={(phone, country) =>
                        handleChangeShippingPhone(phone, country)
                      }
                      inputStyle={{ width: "100%" }}
                      buttonClass="phoneBtn"
                      placeholder="Phone Number"
                    />
                    <p className="err_msg">
                      {error && !ShippingFormik.values.contactPhone?.length
                        ? "Phone number is required"
                        : ""}
                    </p>
                  </div>

                  {/* ---------------- PICKUP INSTRUCTIONS ---------------- */}
                  <div className="control_group w_100">
                    <label>Pickup Instructions</label>

                    <div className="instruction_chips">
                      {pickupInstructionOptions.map((option, i) => (
                        <button
                          key={i}
                          type="button"
                          className={`instruction_chip ${
                            selectedInstruction === option ? "selected" : ""
                          }`}
                          onClick={() => {
                            setSelectedInstruction(option);
                            if (option !== "Custom instruction")
                              setCustomInstruction("");
                          }}
                        >
                          {option}
                        </button>
                      ))}
                    </div>

                    {/* custom input appears only when selected */}
                    {selectedInstruction === "Custom instruction" && (
                      <TextField
                        placeholder="Enter your custom instruction"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={customInstruction}
                        onChange={(e) => setCustomInstruction(e.target.value)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Box>

            <div className="gap_p">
              <div className="title_inner">
                <h3>Allow Non-Returnable Products</h3>
              </div>
              <div className="control_group">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={ShippingFormik.values.allowNonReturnableProducts}
                      onChange={(e) =>
                        ShippingFormik.setFieldValue(
                          "allowNonReturnableProducts",
                          e.target.checked
                        )
                      }
                    />
                  }
                  label="For hygiene or customized items only"
                />
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                type="submit"
                variant="contained"
              >
                Save
              </Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={7}>
          <form className="form" onSubmit={DeliveryFormik.handleSubmit}>
            <div className="gap_p">
              {/* ========================== DELIVERY SLA ========================== */}
              <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
                <div className="form">
                  <div className="gap_p">
                    <div className="title_inner">
                      <h3>Delivery SLA (Seller’s Prep Time)</h3>
                      <p style={{ textAlign: "left" }}>
                        How fast can you prepare an order for pickup?
                      </p>
                    </div>

                    {/* RADIO BUTTONS ONLY */}
                    <RadioGroup
                      value={deliverySLA}
                      onChange={(e) => setDeliverySLA(e.target.value)}
                    >
                      <FormControlLabel
                        value={"1"}
                        control={<Radio />}
                        label="Same-day (24h)"
                      />
                      <FormControlLabel
                        value={"2"}
                        control={<Radio />}
                        label="1–2 days"
                      />
                      <FormControlLabel
                        value={"3"}
                        control={<Radio />}
                        label="3 days"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </Box>

              {/* ========================== FAST DELIVERY ========================== */}
              <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
                <div className="form">
                  <div className="gap_p">
                    <div
                      className="title_inner"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h3>Enable Fast Delivery</h3>
                      {/* Toggle Switch */}
                      <Switch
                        checked={fastDeliveryEnabled}
                        onChange={(e) =>
                          setFastDeliveryEnabled(e.target.checked)
                        }
                        color="primary"
                      />
                    </div>
                  </div>
                </div>
                {fastDeliveryEnabled && (
                  <Box sx={{ mt: 2, pl: 1 }}>
                    {" "}
                    {/* 1. Delivery Type */}
                    <p style={{ textAlign: "left" }}> 1. Delivery Type </p>
                    <div style={{ marginTop: "6px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="isSameDayDelivery"
                            checked={DeliveryFormik.values.isSameDayDelivery}
                            onChange={DeliveryFormik.handleChange}
                          />
                        }
                        label="Same-Day Delivery"
                      />
                    </div>{" "}
                    {/* 2. Cut-off time */}{" "}
                    <p className="mt_20" style={{ textAlign: "left" }}>
                      {" "}
                      2. Cut-Off Time{" "}
                    </p>
                    <TextField
                      select
                      size="small"
                      sx={{ mt: 1, width: "200px" }}
                      value={selectedTime}
                      onChange={(e) => setSelectedTime(e.target.value)}
                    >
                      <MenuItem value="12:00">12:00 PM</MenuItem>
                      <MenuItem value="14:00">2:00 PM</MenuItem>
                      <MenuItem value="15:00">3:00 PM</MenuItem>
                      <MenuItem value="16:00">4:00 PM</MenuItem>
                    </TextField>
                    <p className="err_msg">
                      {fastDeliveryEnabled && error && !selectedTime
                        ? "Cut-off time is required"
                        : ""}
                    </p>
                    {/* 3. Region Availability */}
                    <p className="mt_20" style={{ textAlign: "left" }}>
                      {" "}
                      3. Region Availability{" "}
                    </p>
                    <RadioGroup
                      value={scope}
                      onChange={handleScopeChange}
                      sx={{ mt: 1 }}
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All UAE"
                      />
                      <FormControlLabel
                        value="specific"
                        control={<Radio />}
                        label="Specific Emirates"
                      />
                    </RadioGroup>
                    {/* Emirates checkboxes */}
                    <Box sx={{ pl: 3, mt: 1 }}>
                      {ALL_PLACES.map((place) => (
                        <FormControlLabel
                          key={place}
                          control={
                            <Checkbox
                              checked={places.includes(place)}
                              disabled={scope === "all"}
                              onChange={() => handlePlaceToggle(place)}
                            />
                          }
                          label={place}
                        />
                      ))}
                    </Box>
                    {/* 4. Information Box */}{" "}
                    <Box
                      sx={{
                        mt: 3,
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        background: "#FFF7E6",
                      }}
                    >
                      <Typography sx={{ fontWeight: 600, mb: 1 }}>
                        {" "}
                        Vendor Responsibility{" "}
                      </Typography>
                      <Typography sx={{ fontSize: "14px", lineHeight: 1.6 }}>
                        {" "}
                        You must have the order ready for pickup on time. <br />{" "}
                        If not ready, fast delivery may be disabled for your
                        store.{" "}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>

              {/* ========================== RETURN MANAGEMENT ========================== */}
              <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
                <div className="title_inner">
                  <h3>Return Management</h3>
                </div>
                <div className="gap_p">
                  {/* Return & Exchange Options */}
                  <div className="control_group w_100">
                    <label>Return & Exchange Policy</label>
                    <TextField
                      select
                      fullWidth
                      value={DeliveryFormik.values.returnPolicyType}
                      onChange={(e) => {
                        const value = e.target.value;

                        DeliveryFormik.setFieldValue("returnPolicyType", value);

                        // If not custom → save menu value directly
                        if (value !== "custom") {
                          DeliveryFormik.setFieldValue(
                            "returnPolicyValue",
                            value
                          );
                        } else {
                          DeliveryFormik.setFieldValue("returnPolicyValue", "");
                        }
                      }}
                    >
                      <MenuItem value="Standard Return – 7 days">
                        Standard Return – 7 days
                      </MenuItem>
                      <MenuItem value="Exchange Only – 7 days">
                        Exchange Only – 7 days
                      </MenuItem>
                      <MenuItem value="No Returns (personalized / hygiene)">
                        No Returns (personalized / hygiene)
                      </MenuItem>
                      <MenuItem value="custom">Custom</MenuItem>
                    </TextField>

                    {/* Custom Return Box */}
                    {DeliveryFormik.values.returnPolicyType === "custom" && (
                      <TextField
                        id="returnPolicyValue"
                        name="returnPolicyValue"
                        multiline
                        fullWidth
                        sx={{ mt: 2 }}
                        placeholder="Enter custom return conditions"
                        value={DeliveryFormik.values.returnPolicyValue}
                        onChange={(e) =>
                          DeliveryFormik.setFieldValue(
                            "returnPolicyValue",
                            e.target.value
                          )
                        }
                        onBlur={DeliveryFormik.handleBlur}
                        helperText={
                          DeliveryFormik.touched.returnPolicyValue &&
                          typeof DeliveryFormik.errors.returnPolicyValue ===
                            "string"
                            ? DeliveryFormik.errors.returnPolicyValue
                            : ""
                        }
                      />
                    )}
                  </div>

                  {/* Return Address */}
                  <div className="control_group w_100">
                    <label>
                      Return Address
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={DeliveryFormik.values.sameAsPickup}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              DeliveryFormik.setFieldValue(
                                "sameAsPickup",
                                checked
                              );

                              if (checked) {
                                DeliveryFormik.setFieldValue(
                                  "returnAddress",
                                  vendorData?.shippingAddress?.detail || ""
                                );
                              } else {
                                DeliveryFormik.setFieldValue(
                                  "returnAddress",
                                  ""
                                );
                              }
                            }}
                          />
                        }
                        label="Same as Pickup Address"
                      />
                    </label>

                    <TextField
                      id="returnAddress"
                      name="returnAddress"
                      multiline
                      fullWidth
                      placeholder="Enter return address"
                      className="text_field"
                      value={DeliveryFormik.values.returnAddress}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          DeliveryFormik.handleChange(val);
                        }
                      }}
                      onBlur={DeliveryFormik.handleBlur}
                      helperText={
                        DeliveryFormik.touched.returnAddress &&
                        typeof DeliveryFormik.errors.returnAddress === "string"
                          ? DeliveryFormik.errors.returnAddress
                          : ""
                      }
                    />
                  </div>
                </div>
              </Box>

              <div className="form_btn">
                <Button
                  className="btn btn_primary"
                  type="submit"
                  variant="contained"
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={8}>
          <form className="form" onSubmit={SocialFormik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="phoneNumber">Facebook Link</label>
                <TextField
                  id="facebook"
                  name="facebook"
                  placeholder=" Facebook Link"
                  type="text"
                  fullWidth
                  className="text_field"
                  value={SocialFormik.values.facebook}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      SocialFormik.handleChange(val);
                    }
                  }}
                  onBlur={SocialFormik.handleBlur}
                  helperText={
                    SocialFormik.touched.facebook &&
                    typeof SocialFormik.errors.facebook === "string"
                      ? SocialFormik.errors.facebook
                      : ""
                  }
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="phoneNumber">Instagram Link</label>
                <TextField
                  id="instagram"
                  name="instagram"
                  placeholder=" Instagram Link"
                  type="text"
                  fullWidth
                  className="text_field"
                  value={SocialFormik.values.instagram}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      SocialFormik.handleChange(val);
                    }
                  }}
                  onBlur={SocialFormik.handleBlur}
                  helperText={
                    SocialFormik.touched.instagram &&
                    typeof SocialFormik.errors.instagram === "string"
                      ? SocialFormik.errors.instagram
                      : ""
                  }
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="phoneNumber">Twitter Link</label>
                <TextField
                  id="twitter"
                  name="twitter"
                  placeholder=" Twitter Link"
                  type="text"
                  fullWidth
                  className="text_field"
                  value={SocialFormik.values.twitter}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      SocialFormik.handleChange(val);
                    }
                  }}
                  onBlur={SocialFormik.handleBlur}
                  helperText={
                    SocialFormik.touched.twitter &&
                    typeof SocialFormik.errors.twitter === "string"
                      ? SocialFormik.errors.twitter
                      : ""
                  }
                />
              </div>

              <div className="control_group w_50">
                <label htmlFor="phoneNumber">Tik Tok</label>
                <TextField
                  id="tiktok"
                  name="tiktok"
                  placeholder="Tik Tok Link"
                  type="text"
                  fullWidth
                  className="text_field"
                  value={SocialFormik.values.tiktok}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      SocialFormik.handleChange(val);
                    }
                  }}
                  onBlur={SocialFormik.handleBlur}
                  helperText={
                    SocialFormik.touched.tiktok &&
                    typeof SocialFormik.errors.tiktok === "string"
                      ? SocialFormik.errors.tiktok
                      : ""
                  }
                />
              </div>
            </div>
            <div className="form_btn mt_20">
              <Button className="btn btn_primary" type="submit">
                Save
              </Button>
            </div>
          </form>
        </CustomTabPanel>
      </div>

      <SelectUpload
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default StoreInformation;
